module.exports = __webpack_public_path__ + "static/media/Asaas-list-decoration.fbd50912.svg";